var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 156,
    viewBox: "0 0 170 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37852_12793)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 158,
    height: 144,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37852_12793)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_37852_12793)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.8276,
    y: 12,
    width: 94.3444,
    height: 52.249,
    rx: 2.29952,
    fill: "#E2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.521 45.2215C77.694 45.2215 80.2662 42.6495 80.2662 39.4766C80.2662 36.3036 77.694 33.7314 74.521 33.7314C71.3481 33.7314 68.7759 36.3036 68.7759 39.4766C68.7759 42.6495 71.3481 45.2215 74.521 45.2215Z",
    fill: "#FFC011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9809 35.7275L52.4526 64.249H116.999L101.262 26.3004C100.94 25.5241 99.8626 25.467 99.4605 26.2051L87.7975 47.6163L83.8932 39.6515C83.5419 38.935 82.5342 38.8983 82.1317 39.5874L76.1734 49.7899L68.7567 35.7152C68.3787 34.9979 67.349 35.005 66.9809 35.7275Z",
    fill: "#67BB6A"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 76.249,
    width: 142,
    height: 6,
    rx: 3,
    fill: "#E6E6E6",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 90.249,
    width: 44,
    height: 6,
    rx: 3,
    fill: "#E6E6E6",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 108.249,
    width: 14,
    height: 8,
    rx: 4,
    fill: "#E6E6E6",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 108.249,
    width: 14,
    height: 8,
    rx: 4,
    fill: "#E6E6E6",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 108.249,
    width: 14,
    height: 8,
    rx: 4,
    fill: "#E6E6E6",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 108.249,
    width: 14,
    height: 8,
    rx: 4,
    fill: "#E6E6E6",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37852_12793",
    x: 0,
    y: 0,
    width: 170,
    height: 156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.0941176 0 0 0 0 0.117647 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37852_12793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37852_12793",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37852_12793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.3444,
    height: 52.249,
    fill: "white",
    transform: "translate(37.8276 12)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_37852_12793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.3444,
    height: 52.249,
    fill: "white",
    transform: "translate(37.8276 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingProduct);
export default __webpack_public_path__ + "static/media/onboarding-product.539c6b1cbd0cf9a9acd8c52198d032f9.svg";
export { ForwardRef as ReactComponent };